// GENERAL
import React from "react";

// COMPONENTS
import { BaseContainer, BaseText } from "../../../../../../components";

import OrderShipment from "../shipments/OrderShipment";

// TYPES
import { Shipments } from "../../types";

export interface OrderShipmentsSectionProps {
	shipmentData: Shipments[] | string[];
	reasonForRequestAndShippingInstructionsNotes: boolean;
	fields?: { [key: string]: any };
}

const OrderShipmentsSection: React.FC<OrderShipmentsSectionProps> = ({
	shipmentData,
	reasonForRequestAndShippingInstructionsNotes,
	fields,
}) => {
	// CLASSES:
	const shipmentsBaseContainerClasses =
		"flex flex-col items-start w-full mb-30 py-3 px-4 border-transparent";

	return (
		<>
			<section>
				{shipmentData?.length !== 0 && (
					<div
						className={`flex flex-col items-start  max-xl:w-full mb-30 max-xl:ml-0`}
					>
						<BaseContainer
							columnContainerClasses={
								shipmentsBaseContainerClasses
							}
							columnShape="semi-rounded"
							borderColor="navy-200"
							backgroundColor="bg-navy-100"
							isDisabled={false}
							children={
								<div
									className={
										"flex flex-col items-start w-full h-full"
									}
								>
									<div
										className={
											"flex flex-col items-start w-full h-full"
										}
									>
										<BaseText
											text={
												fields?.labels
													?.shipmentsSectionTitle ||
												"Shipments"
											}
											size="text-sm"
											fontFamily="font-omnes-medium"
											tag="h3"
											color="text-navy-500"
										/>
										<div
											className={`${
												reasonForRequestAndShippingInstructionsNotes
													? " grid grid-cols-1"
													: "grid grid-cols-3"
											}  gap-2 w-full py-3 max-lg:grid-cols-1`}
										>
											{shipmentData?.map(
												(shipment: Shipments) => (
													<div
														key={
															typeof shipment ===
															"string"
																? shipment
																: shipment.uuid
														}
														className="flex w-full"
													>
														{typeof shipment ===
														"string" ? (
															<div
																className={`flex flex-col items-start px-1.5 py-1 text-sm bg-white rounded-lg col-span-1 h-[76px] w-full`}
															>
																{shipment}
															</div>
														) : (
															<OrderShipment
																shipmentData={
																	shipment
																}
																containerClasses="w-full"
																shape="rounded-lg"
																borderColor=""
																backgroundColor="bg-white"
																additionalClasses="col-span-1 h-[76px]"
																fontFamily="font-omnes-regular"
																textSize="text-sm"
															/>
														)}
													</div>
												),
											)}
										</div>
									</div>
									<div className="flex w-full h-1/4 items-end">
										<BaseText
											text={`${shipmentData?.length} ${fields?.labels?.shipmentCountSuffix}`}
											size="text-sm"
											fontFamily="font-omnes-regular"
											tag="h3"
											color="text-navy-300"
										/>
									</div>
								</div>
							}
						/>
					</div>
				)}
			</section>
		</>
	);
};

export default OrderShipmentsSection;
